export const CHAT_API_VERSION = 3.5;
export const HELP_DESK_API_VERSION = 1;
export const SOCKET_URL = `wss://api.livechatinc.com/v${CHAT_API_VERSION}/customer/rtm/ws`;
export const CHAT_API_URL = `https://api.livechatinc.com/v${CHAT_API_VERSION}`;
export const HELP_DESK_API_URL = `https://api.helpdesk.com/v${HELP_DESK_API_VERSION}`;

export const CHAT_PUSHES = [
  'chat_deactivated',
  'chat_properties_deleted',
  'chat_properties_updated',
  'chat_transferred',
  'customer_side_storage_updated',
  'customer_updated',
  'events_marked_as_seen',
  'event_properties_deleted',
  'event_properties_updated',
  'event_updated',
  'greeting_accepted',
  'greeting_canceled',
  'groups_status_updated',
  'incoming_chat',
  'incoming_event',
  'incoming_greeting',
  'incoming_multicast',
  'incoming_rich_message_postback',
  'incoming_typing_indicator',
  'queue_position_updated',
  'thread_properties_deleted',
  'thread_properties_updated',
  'user_added_to_chat',
  'user_removed_from_chat',
];
